import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import { API_BASE_URL } from '../config';
import { useCart } from '../CartContext';
import placeholderImage from "../images/Placeholder.png";


{/* <section id="reviewsSection">
        <h2>What our customers have to say</h2>
        {/TEMP/}
        <div className="reviews-carousel-left"><i className="bi bi-chevron-compact-left"></i></div>
        <div className="reviews-carousel-right"><i className="bi bi-chevron-compact-right"></i></div>
        <article className="review-card">

          <div className="review-person"><i className="bi bi-person-fill"></i></div>
          <div className="review-name-container">
            <h4>Jaime Castillo</h4>
            <span>Ordered on 3/17/25</span>
          </div>

          <p>Shipping was super fast, and my order arrived beautifully packaged with a handwritten note. It’s clear that this team puts so much love into what they do. I’ll definitely be back for more crystals and botanicals – next on my list is the Rose Quartz and some sage bundles! Thank you for creating such a wonderful experience!</p>
          <span className="review-quote">"</span>
        </article>
        {/END TEMP/}
      </section> */}

function Home() {
   const { cart, addToCart, updateQuantity, removeFromCart } = useCart();
  const [featuredProducts, setFeaturedProducts] = useState(null);

  useEffect(() => {
    axios.get(`${API_BASE_URL}/api/featured`)
      .then((response) => {
        setFeaturedProducts(response.data)
      })
      .catch((error) => {
        console.error("Error fetching products:", error)
        setFeaturedProducts("Error while fetching products. Please reload the page or contact customer service for support.")
      });
  }, []);
  return (
    <div className="App">

      <section id="heroSection">
        <div className="heroContainer">
          <h1>Elevate Your Energy with Earth’s Finest Gifts</h1>
          <p>Explore our curated collection and find the perfect piece to elevate your space and spirit.</p>
          <Link to="/categories" type="button" className="mainButton">Shop</Link>
        </div>
        <div className="hero-image" ></div>
        <article>
          <div>
            <i className="bi bi-truck"></i>
            <div>
              <b>Free Shipping</b>
              <p>On orders bigger than $50</p>
            </div>

          </div>
          <div>
            <i className="bi bi-piggy-bank"></i>
            <div>
              <b>15 Days Guarantee</b>
              <p>Moneyback guarantee</p>
            </div>

          </div>
          <div>
            <i className="bi bi-key"></i>
            <div>
              <b>Secure Checkout</b>
              <p>Secured by Stripe</p>
            </div>

          </div>
        </article>
      </section>
      <section id="categorySection">
        <Link to={`/crystals`} className="category-crystals"><span>Crystals</span></Link>
        <Link to={`/botanicals`} className="category-botanicals"><span>Botanicals</span></Link>
        <Link to={`/all`} className="category-all"><span>All</span></Link>
      </section>
      <section id="featuredSection">
        <h2>Discover the Beauty of Our Handpicked Crystals and Botanicals</h2>
        <p>Explore our <i>featured</i> products!</p>
        {/* TEMP */}
        <article className="card-container">
          {featuredProducts != null ? featuredProducts.map((feat, i) => {
            const splitName = feat.name.split("(");
            let totalRating = 0;
            let totalRatingUsers = 0;
            for (let rating in feat.reviews) {
              const ratingArray = feat.reviews[rating];
              totalRating = totalRating + (Number(rating) * ratingArray.length);
              totalRatingUsers = totalRatingUsers + ratingArray.length;
            }
            const reviewIcons = [];
            for (let i = 0; i < 5; i++) {
              const avgRating = (totalRating == 0 && totalRatingUsers == 0) ? 0 : totalRating / totalRatingUsers;
              const starName = avgRating < (i + .24) ? "bi-star" : avgRating < (i + .74) && avgRating > (i + .24) ? "bi-star-half" : "bi-star-fill";
              const starIcon = React.createElement("i", { className: `star-icons bi ${starName}` });
              reviewIcons.push(starIcon);
            }
            return (
              <>
                {/* <div className="card-item">
                  <div className="card-item-1"></div>
                  <span>{feat.name}</span>
                  <div><i className="bi bi-star"></i><i className="bi bi-star"></i><i className="bi bi-star"></i><i className="bi bi-star"></i><i className="bi bi-star"></i> <i>Not yet rated</i></div>
                  <p>$3.99</p>
                  <div className="card-options">
                    <button className='card-button-cart'>Add to Cart</button>
                    <button className="card-button-view">View More</button>
                  </div>
                </div> */}

                <div className="card-item-shop" key={feat._id}>
                  {/* <button className='card-button-cart-shop' onClick={() => { addToCart(product) }}><div><i className="bi bi-cart-plus"></i></div></button> */}
                  <Link className="card-link-overlay" to={`/product/${feat.name}`}>
                  </Link>
                  <div className="card-shop-image" style={{ backgroundImage: `url(${feat?.imageURL?.[0]?.includes('/upload/') ? feat.imageURL[0].replace("/upload/", '/upload/c_thumb,w_720/') : placeholderImage})` }}></div>
                  <div className="card-item-details-container">
                    <div>
                      <h3>{splitName[0]}</h3>
                      <i>{splitName?.[1]?.replace(")", "")}</i>
                    </div>
                    <div>
                      <div>{reviewIcons}{(totalRating == 0 && totalRatingUsers == 0) ? " Not yet rated" : ` (${totalRating / totalRatingUsers}) ${totalRatingUsers} rating${totalRatingUsers > 1 ? "s" : ""}`}</div>
                      <p>${feat.price}</p>
                      {cart.some(cartItem => cartItem?.["_id"] == feat?.["_id"])
                        ? (
                          <div className="card-cart-details-container">
                            <div className="cart-products-item-input-container">
                              <button onClick={() => {
                                updateQuantity(feat["_id"], (cart.find(cartItem => cartItem?.["_id"] == feat?.["_id"])["quantity"] - 1))
                              }} className={`${cart.find(cartItem => cartItem?.["_id"] == feat?.["_id"])["quantity"] == 1 ? "cart-products-item-input-button-disabled" : ""}`}><i className="bi bi-dash-lg"></i></button>
                              <p>{cart.find(cartItem => cartItem?.["_id"] == feat?.["_id"])["quantity"]}</p>
                              <button onClick={() => {
                                addToCart(cart.find(cartItem => cartItem?.["_id"] == feat?.["_id"]))
                              }} className={`${feat.quantity == cart.find(cartItem => cartItem?.["_id"] == feat?.["_id"])["quantity"] ? "cart-products-item-input-button-disabled" : ""}`}>
                                <i className="bi bi-plus-lg"></i>
                              </button>
                            </div>
                            <button className="card-cart-remove-button" onClick={() => {
                              removeFromCart(feat._id)
                            }}>
                              <i className="bi bi-trash"></i>
                            </button>
                          </div>
                        )
                        :
                        (<button className='card-button-cart-shop' onClick={() => { addToCart(feat) }}>Add to cart <i className="bi bi-cart-plus"></i></button>)}
                    </div>
                  </div>
                </div>
              </>
            )
          }) : ""}



        </article>
        <h2>Have any questions about our products?</h2>
        <p className="home-questions-description">We highly suggest you check out our <Link to="/FAQ">FAQ</Link> page or, alternatively, reach out directly to us via our <Link to="/Contact">contact</Link> page!</p>
        <br>
        </br>
        <article className="home-questions-container">
          <div>
            <i className="bi bi-chat-text"></i>
            <h3>FAQ</h3>
            <p>Discover answers to common questions in our comprehensive FAQ section, designed to provide clear and concise solutions to your inquiries.</p>
            <Link to="/FAQ">Explore FAQs <i className="bi bi-arrow-right"></i></Link>
          </div>
          <div>
          <i className="bi bi-envelope"></i>
          <h3>Contact</h3>
            <p>Connect with us through our Contact page, where our dedicated team is ready to assist with any questions or support you may need.</p>
            <Link to="/Contact">Reach out <i className="bi bi-arrow-right"></i></Link>
          </div>
        </article>
        <br></br>
        {/* END TEMP */}
      </section>
      
    </div>
  )
}

export default Home;